import { paymentStatuses } from "./payment-presentation";

// Query semantics belong to billing; rendering and draft/reset behavior are shared.
export const paymentReportFilters = [
  { name: "gatewayCode", title: "درگاه پرداخت", type: "enum", emptyTitle: "همه درگاه‌ها",
    options: [{ value: "zarinpal", title: "زرین‌پال" }, { value: "multisafepay", title: "MultiSafepay" }] },
  { name: "search", title: "جستجوی شناسه، مرجع یا شرح", type: "string", maxLength: 200 },
  { name: "status", title: "وضعیت پرداخت", type: "enum", emptyTitle: "همه وضعیت‌ها",
    options: Object.entries(paymentStatuses).map(([value, title]) => ({ value, title })) },
  { name: "from", title: "از تاریخ (UTC)", type: "date" },
  { name: "to", title: "تا تاریخ (UTC، شامل این روز)", type: "date", after: "from" },
];
